import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import styled from 'styled-components';
import { legacyType } from '../../../styles/typography';

import Section from '../../common/Section';

import MultiColumnsGridBlock from '../gridBlock/MultiColumnsGridBlock';
import ArticleHero from './ArticleHero';
import Anchor from '../utils/Anchor';

export const Body = styled.div`
  font-size: var(--fs-sm);
  ${legacyType('sm', 'body')};
  margin-bottom: 1rem;

  a {
    text-decoration: underline;
  }
`;

export const Subheader = styled.div`
  text-transform: uppercase;
  font-size: var(--fs-focus);
  font-weight: 500;
  ${legacyType('focus', 'label', { uppercase: true })};
  overflow-wrap: anywhere;
`;

const ArticleGridBlock = ({ content }) => {
  const { blockId } = content;
  const blocks = (content.blocks || []).filter(block => get(block, 'fields'));
  if (isEmpty(blocks)) {
    return null;
  }

  const [heroBlock, ...restBlocks] = blocks;

  const newContent = { ...content, blocks: restBlocks };

  return (
    <React.Fragment>
      <Anchor id={`${blockId}-hero`} />
      {get(heroBlock, 'fields') && (
        <Section sectionMargin="2rem">
          <ArticleHero content={heroBlock.fields} />
        </Section>
      )}
      <MultiColumnsGridBlock content={newContent} />
    </React.Fragment>
  );
};

ArticleGridBlock.propTypes = {
  content: PropTypes.object,
};

export default ArticleGridBlock;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/ArticleGridBlock.js